import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Helmet } from 'react-helmet-async';
import { FaPlus } from 'react-icons/fa';
import heroSmartContracts from '../assets/hero-smart-contracts.jpg';
import heroSmartContractsMobile from '../assets/compressed/mobile/hero-smart-contracts.jpg';
import heroSmartContractsTablet from '../assets/compressed/tablet/hero-smart-contracts.jpg';
import './SmartContracts.css';
import ForumDiscussion from '../components/Forum/ForumDiscussion';
import NouvDiscModal from '../components/Forum/NouvDiscModal';
import useForumPagination from '../hooks/useForumPagination';

const SmartContracts = () => {
    const [showModal, setShowModal] = useState(false);
    const { currentUser } = useAuth();
    const {
        discussions,
        loading,
        hasMore,
        loadMore,
        refreshDiscussions
    } = useForumPagination('smart-contracts-discussions');

    return (
        <main className="smart-contracts-page">
            <Helmet>
                <title>Smart Contracts - Tech Passion</title>
                <meta name="description" content="Découvrez les Smart Contracts : contrats intelligents, blockchain, automatisation des transactions et applications décentralisées. Guide complet sur la technologie révolutionnant les contrats numériques." />
                <link rel="canonical" href="https://techpassion.fr/smart-contracts" />
                <meta name="keywords" content="smart contracts, contrats intelligents, blockchain, ethereum, DApps, applications décentralisées, transactions automatisées, crypto-monnaies" />
                <meta property="og:title" content="Smart Contracts - Tech Passion" />
                <meta property="og:description" content="Explorez les Smart Contracts : technologie blockchain révolutionnant les contrats numériques et l'automatisation des transactions." />
                <meta property="og:url" content="https://techpassion.fr/smart-contracts" />
                <meta property="og:type" content="website" />
            </Helmet>

            <section className="hero">
                <div className="hero-left">
                    <div className="hero-content">
                        <h1>Smart Contracts</h1>
                        <p>Explorez l'univers des contrats intelligents, leur développement et leurs applications</p>
                    </div>
                </div>
                <img 
                    className="hero-image"
                    src={heroSmartContracts}
                    srcSet={`${heroSmartContractsMobile} 480w, ${heroSmartContractsTablet} 768w, ${heroSmartContracts} 1024w`}
                    sizes="(max-width: 768px) 100vw, 50vw"
                    alt="Smart contracts sur la blockchain avec code source et flux d'exécution automatisé"
                    loading="lazy"
                />
            </section>

            <section className="discussions-section">
                {loading ? (
                    <div className="loading">Chargement des discussions...</div>
                ) : (
                    <div className="discussions-container">
                        {discussions.map(discussion => (
                            <ForumDiscussion
                                key={discussion.id}
                                discussion={discussion}
                                collectionName="smart-contracts-discussions"
                                onReply={refreshDiscussions}
                            />
                        ))}
                    </div>
                )}

                {hasMore && (
                    <div className="load-more-container">
                        <button 
                            className="load-more-btn"
                            onClick={loadMore}
                        >
                            Voir plus
                        </button>
                    </div>
                )}
            </section>

            {currentUser && (
                <button 
                    className="new-discussion-button" 
                    title="Nouvelle discussion"
                    onClick={() => setShowModal(true)}
                >
                    <FaPlus />
                </button>
            )}

            <NouvDiscModal 
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                forumId="smart-contracts-discussions"
                onDiscussionUpdate={refreshDiscussions}
            />
        </main>
    );
};

export default SmartContracts;
